import axios from '../axios';

const fetchProjectStatistics = async (projectId: string) => {
  const { data } = await axios.get(`/projects/${projectId}/statistics`);

  return data;
};

export default fetchProjectStatistics;
